import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { ActivatedRoute } from '@angular/router';
import {
  BreadcrumbItem,
  QaiBreadcrumbListComponent,
  QaiInnerWrapComponent,
  QaiLoadingComponent,
} from '@qai/ui';
import { IPersonalPracticeSim } from 'src/app/interfaces/personalized-practice/ipersonalized-practice-simulation';
import { PersonalizedPracticeService } from 'src/app/services/personalized-practice/personalized-practice.service';
import { ScenarioDetailsComponent } from './scenario-details/scenario-details.component';
import { PersonalizedPracticePreviousSessionsComponent } from '../personalized-practice-previous-sessions/personalized-practice-previous-sessions.component';
import { TranslationService } from 'src/app/services/translation.service';
import { getAccountNameByUuid } from 'src/app/utils/local-storage.util';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';

@Component({
  selector: 'app-personalized-product-details',
  templateUrl: './personalized-product-details.component.html',
  styleUrls: ['./personalized-product-details.component.scss'],
  standalone: true,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'personalizedPractice',
    },
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    QaiInnerWrapComponent,
    QaiBreadcrumbListComponent,
    ScenarioDetailsComponent,
    QaiLoadingComponent,
    PersonalizedPracticePreviousSessionsComponent,
  ],
})
export class PersonalizedProductDetailsComponent implements OnInit {
  simulation: IPersonalPracticeSim | null = null;
  isLoading = true;
  simulationUuid: string | null = null;
  isTranslationLoaded = false;

  // Properties to pass to previous sessions component
  accountUuid: string = '';
  accountName: string = '';
  isActive: boolean = false;
  isComplete: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private personalizedPracticeService: PersonalizedPracticeService,
    private translationService: TranslationService,
    private amplitudeService: AmplitudeService,
  ) { }

  ngOnInit(): void {
    this.translationService
      .loadScopedTranslation('personalizedPractice')
      .then(() => {
        this.isTranslationLoaded = true;
      });

    this.accountUuid = localStorage.getItem('current_account_uuid') || '';
    this.accountName = getAccountNameByUuid(this.accountUuid);
    this.simulationUuid = this.route.snapshot.paramMap.get('uuid');

    if (this.simulationUuid) {
      this.loadSimulationDetails();
    }
  }

  loadSimulationDetails(): void {
    this.isLoading = true;
    this.personalizedPracticeService
      .getPersonalizedPracticeSimulations()
      .subscribe({
        next: (simulations: IPersonalPracticeSim[]) => {
          this.simulation =
            simulations.find((s) => s.moduleUuid === this.simulationUuid) || null;
          this.amplitudeService.trackEvent(
            AmplitudeTrackingEvents.PERSONALIZED_PRACTICE_PAGE_PAGEVIEW, {
              account_name: this.accountName,
              product_name: this.simulation?.moduleName || '',
            }
          );
          this.isActive = this.simulation?.isActive || false;
          this.isComplete = this.simulation?.isComplete || false;
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error loading simulation details:', error);
          this.isLoading = false;
        },
    });
  }

  getBreadcrumbItems(): BreadcrumbItem[] {
    return [
      {
        text: this.translationService.translate(
          'BREADCRUMB',
          'personalizedPractice'
        ),
        href: '/personalized-practice',
      },
      { text: '', href: '', active: true },
    ];
  }
}
